@if ($model() != null) {
    <form class="px-1" (ngSubmit)="onSubmit()" #flowObjectDetails="ngForm">
        <div class="scroll-wrapper styled-scrollbar px-1">
            <!-- Nome -->
            <ng-container>
                <div class="form-group" featureHint="flowObjectDetails|Name" featureHintHAlign="right" featureHintExclusiveGroup>
                    <label for="name">Nome</label>

                    <input type="text" class="form-control" id="name" name="name" #nameElem="ngModel" maxlength="100" required
                           [ngModel]="$name()"
                           (input)="$name.set($event.target.value)"
                    >
                </div>
                <div [hidden]="nameElem.valid || nameElem.pristine" class="alert alert-danger">Campo obrigatório</div>
            </ng-container>

            <!-- Nome Público -->
            <ng-container>
                <div class="form-group" featureHint="flowObjectDetails|PublicName" featureHintHAlign="right" featureHintShowOn="right">
                    <label for="publicName">Nome Público</label>

                    <input type="text" class="form-control" id="publicName" name="publicName" maxlength="100"
                           [ngModel]="$publicName()"
                           (input)="$publicName.set($event.target.value)"
                    >
                </div>
            </ng-container>

            <!-- Conteúdo exclusivo para Tarefas que exibam a "Mensagem Pública Customizada" -->
            @if ($shouldShowPublicMessageHtml()) {
                <div class="form-group" featureHintHAlign="right" featureHintVAlign="top" featureHintShowOn="right"
                     [attr.featureHint]="$isPublicMessageHtmlBefore() ? 'flowObjectDetails|PublicMessageHtmlBefore' : 'flowObjectDetails|PublicMessageHtmlAfter'"
                >
                    @if ($isPublicMessageHtmlBefore()) {
                        <label for="publicMessageHtml">Mensagem ao usuário enquanto aguarda a conclusão da Tarefa</label>
                    } @else {
                        <label for="publicMessageHtml">Mensagem ao usuário após a conclusão da Tarefa</label>
                    }

                    <editor name="publicMessageHtml" apiKey="no-api-key"
                            [ngModel]="$publicMessageHtml()"
                            [init]="$tinyMceOptions()"
                            (ngModelChange)="$publicMessageHtml.set($event)"
                    ></editor>
                    <textarea id="tinyMce" class="d-none"></textarea>
                </div>
            }

            <!-- Conteúdo exclusivo para Tarefas que gerem captura de Documento como resultado de sua execução -->
            @if ($shouldShowFlowObjectDetailsDocument()) {
                <fod-document #flowObjectDetailsDocumentRef
                              [_configSchema]="$configSchema()"
                              [_flowDefinition]="$flowDefinition()"
                              [_flowObjectDefinition]="$model()"
                              [_isReadOnlyMode]="$isReadOnlyMode()"
                              (_configSchemaChangeEvent)="Utils.setSignal($configSchema, $event)"
                ></fod-document>
            }

            @switch ($model().typeId) {
                @case (FlowObjectType.TaskForward) {
                    <!-- Conteúdo exclusivo para Tarefas do tipo "TaskForward" -->
                    <fod-forward #flowObjectDetailsForwardRef
                                 [_configSchema]="$configSchema()"
                                 [_flowDefinition]="$flowDefinition()"
                                 [_flowObjectDefinition]="$model()"
                                 [_isReadOnlyMode]="$isReadOnlyMode()"
                                 (_recipientModeChange)="updateRecipientMode($event)"
                                 (_configSchemaChangeEvent)="Utils.setSignal($configSchema, $event)"
                    ></fod-forward>
                }
                @case (FlowObjectType.TaskRegisterProcess) {
                    <!-- Conteúdo exclusivo para Tarefas do tipo "TaskRegisterProcess" -->
                    <fod-register-process #flowObjectDetailsRegisterProcessRef
                                          [_configSchema]="$configSchema()"
                                          [_flowDefinition]="$flowDefinition()"
                                          [_isReadOnlyMode]="$isReadOnlyMode()"
                                          (_configSchemaChangeEvent)="Utils.setSignal($configSchema, $event)"
                    ></fod-register-process>
                }
                @case (FlowObjectType.TaskDispatchProcess) {
                    <!-- Conteúdo exclusivo para Tarefas do tipo "TaskDispatchProcess" -->
                    <fod-dispatch-process #flowObjectDetailsDispatchProcessRef
                                          [_configSchema]="$configSchema()"
                                          [_flowDefinition]="$flowDefinition()"
                                          [_isReadOnlyMode]="$isReadOnlyMode()"
                                          (_recipientModeChange)="updateRecipientMode($event)"
                                          (_configSchemaChangeEvent)="Utils.setSignal($configSchema, $event)"
                    ></fod-dispatch-process>
                }
                @case (FlowObjectType.TaskAddToProcess) {
                    <!-- Conteúdo exclusivo para Tarefas do tipo "TaskAddToProcess" -->
                    <fod-add-to-process #flowObjectDetailsAddToProcessRef
                                        [_configSchema]="$configSchema()"
                                        [_flowDefinition]="$flowDefinition()"
                                        [_isReadOnlyMode]="$isReadOnlyMode()"
                                        (_processOriginChangeEvent)="updateProcessOrigin($event)"
                                        (_configSchemaChangeEvent)="Utils.setSignal($configSchema, $event)"
                                        (_isProcessProtocolValidEvent)="$isProcessProtocolValid.set($event)"
                    ></fod-add-to-process>
                }
            }
        </div>

        <!-- Botões -->
        <div class="form-footer text-right mb-1">
            <hr class="mt-0" />

            <!-- ConfigSchema -->
            <div class="button-wrapper float-left ml-1" featureHint="flowObjectDetails|ConfigSchemaButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="button" class="btn btn-outline-secondary" (click)="showConfigSchema()">Editar código-fonte</button>
            </div>

            <!-- Cancelar -->
            <div class="button-wrapper mr-2" featureHint="flowObjectDetails|CancelButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="button" class="btn btn-outline-danger" (click)="closeForm()">Cancelar</button>
            </div>

            <!-- Salvar -->
            <div class="button-wrapper" featureHint="flowObjectDetails|SaveButton" featureHintVAlign="bottom" featureHintShowOn="right">
                <button type="submit" class="btn btn-outline-primary"
                        [class.read-only]="$isReadOnlyMode()"
                        [disabled]="
                            !flowObjectDetails.form.valid
                            || ($model().typeId == FlowObjectType.TaskForward && !$isRadioSelectionValid())
                            || ($model().typeId == FlowObjectType.TaskAddToProcess && !$isProcessProtocolValid())
                            || $isReadOnlyMode()
                        "
                >Salvar Rascunho</button>
            </div>
        </div>
    </form>

    <!-- Modal do ConfigSchema -->
    <ng-template #configSchemaRef>
        <i class="button fas fa-times close" matTooltip="Fechar" (click)="configSchemaDialog.close()"></i>

        <button type="button" class="button btn btn-primary" (click)="Utils.copyToClipboard(configSchemaEditorRef, copyInfoRef);">
            <i class="fas fa-copy mr-2"></i>
            <span>Copiar conteúdo</span>
        </button>

        <button type="button" class="button btn btn-outline-info info" #copyInfoRef><span>Conteúdo copiado!</span></button>
        <button type="button" class="button btn btn-outline-info info" #pasteInfoRef><span>Conteúdo colado!</span></button>

        <button type="button" class="button btn btn-success right" (click)="Utils.pasteFromClipboard(configSchemaEditorRef, pasteInfoRef)">
            <i class="fas fa-paste mr-2"></i>
            <span>Colar conteúdo</span>
        </button>

        <textarea class="schema-editor form-control styled-scrollbar" [ngModel]="$configSchemaFlat()" #configSchemaEditorRef></textarea>
    </ng-template>
}
